import { render, staticRenderFns } from "./MTableHeaderSorting.vue?vue&type=template&id=05a14ffc"
import script from "./MTableHeaderSorting.vue?vue&type=script&lang=js"
export * from "./MTableHeaderSorting.vue?vue&type=script&lang=js"
import style0 from "./MTableHeaderSorting.vue?vue&type=style&index=0&id=05a14ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports